import React from 'react';
import { Form } from 'react-bootstrap';

const SharedDropdown = ({
  name,
  label,
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  className = '',
  error,
  disabled = false,
}) => {
  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const transformedValue = selectedValue === '' ? null : selectedValue;

    if (onChange) {
      // Mimic original event structure
      onChange({
        target: {
          name,
          value: transformedValue,
        },
      });
    }
  };

  return (
    <Form.Group className="custom-form">
      {label && <Form.Label className="color-head">{label}</Form.Label>}
      <Form.Control
        as="select"
        name={name}
        value={value ?? ''}
        onChange={handleSelectChange}
        className={className}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>

        {Array.isArray(options) && options.length > 0 ? (
          options.map((item, index) => (
            <option key={name + index} value={item.value}>
              {item.label}
            </option>
          ))
        ) : (
          <option value="" disabled>
            {placeholder} Are Not Available
          </option>
        )}
      </Form.Control>

      {error && <div className="text-danger">{error}</div>}
    </Form.Group>
  );
};

export default SharedDropdown;
